var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "form-block"
  }, [_c("div", {
    staticClass: "source"
  }, [_c("el-form", {
    ref: "formData",
    staticClass: "demo-form",
    attrs: {
      model: _vm.formData,
      "status-icon": "",
      rules: _vm.rules,
      "label-position": "left"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Enabled",
      prop: "enabled"
    }
  }, [_c("el-switch", {
    model: {
      value: _vm.formData.enabled,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "enabled", $$v);
      },
      expression: "formData.enabled"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Full Name",
      prop: "fullName"
    }
  }, [_c("el-input", {
    attrs: {
      name: "fullName",
      required: "",
      placeholder: "Full Name"
    },
    model: {
      value: _vm.formData.fullName,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "fullName", $$v);
      },
      expression: "formData.fullName"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Mobile Number",
      prop: "mobileNumber"
    }
  }, [_c("el-input", {
    attrs: {
      name: "mobileNumber",
      placeholder: "Mobile Number"
    },
    model: {
      value: _vm.formData.mobileNumber,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "mobileNumber", $$v);
      },
      expression: "formData.mobileNumber"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Email",
      prop: "emailAddress"
    }
  }, [_c("el-input", {
    attrs: {
      name: "emailAddress",
      required: "",
      placeholder: "Email"
    },
    model: {
      value: _vm.formData.emailAddress,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "emailAddress", $$v);
      },
      expression: "formData.emailAddress"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Role",
      required: ""
    }
  }, [_c("el-select", {
    attrs: {
      filterable: "",
      placeholder: "Select"
    },
    on: {
      change: _vm.checkOwnerRole
    },
    model: {
      value: _vm.selectedRoles,
      callback: function ($$v) {
        _vm.selectedRoles = $$v;
      },
      expression: "selectedRoles"
    }
  }, _vm._l(_vm.roleList, function (role) {
    return _c("el-option", {
      key: role.id,
      attrs: {
        label: role.name,
        value: role.id
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "Dealers"
    }
  }, [_c("el-select", {
    attrs: {
      filterable: "",
      multiple: "",
      disabled: _vm.isOwner,
      placeholder: "Select"
    },
    model: {
      value: _vm.selectedDealerIds,
      callback: function ($$v) {
        _vm.selectedDealerIds = $$v;
      },
      expression: "selectedDealerIds"
    }
  }, _vm._l(_vm.dealerList, function (dealer) {
    return _c("el-option", {
      key: dealer.id,
      attrs: {
        label: dealer.name,
        value: dealer.id
      }
    });
  }), 1)], 1), _vm.isSuperAdminUser() ? _c("el-form-item", {
    attrs: {
      label: "Branches"
    }
  }, [_c("el-select", {
    attrs: {
      filterable: "",
      multiple: "",
      "collapse-tags": true,
      placeholder: "Select Branches",
      "loading-text": "Loading branch options...",
      loading: _vm.branchesLoading
    },
    model: {
      value: _vm.assignedBranches,
      callback: function ($$v) {
        _vm.assignedBranches = $$v;
      },
      expression: "assignedBranches"
    }
  }, _vm._l(_vm.branches, function (branch) {
    return _c("el-option", {
      key: branch.id,
      attrs: {
        label: branch.code,
        value: branch.id
      }
    });
  }), 1)], 1) : _vm._e(), _vm.canChangePassword ? _c("el-form-item", {
    attrs: {
      label: "Change Password",
      prop: "changePassword"
    }
  }, [_c("el-switch", {
    on: {
      change: _vm.resetPassword
    },
    model: {
      value: _vm.changePassword,
      callback: function ($$v) {
        _vm.changePassword = $$v;
      },
      expression: "changePassword"
    }
  })], 1) : _vm._e(), _vm.changePassword || !_vm.isEdit ? _c("el-form-item", {
    attrs: {
      label: "Password",
      prop: "password"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Enter password",
      "show-password": ""
    },
    model: {
      value: _vm.formData.password,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "password", $$v);
      },
      expression: "formData.password"
    }
  })], 1) : _vm._e(), _c("el-form-item", [_c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }, {
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      type: "success"
    },
    on: {
      click: _vm.submitForm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.save")) + " ")]), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      type: "reset"
    },
    on: {
      click: _vm.resetForm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.reset")) + " ")])], 1)], 1)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };